<form class="modal-body" #form="ngForm">
  <div class="form-group">
    <div class="btn-group btn-group-justified d-flex">
      <input
        class="btn-check"
        type="radio"
        [(ngModel)]="type"
        value="anonymous"
        name="typeAnonymous"
        id="typeAnonymous"
      />
      <label
        class="btn btn-outline-secondary no-wrap"
        [class.active]="type === 'anonymous'"
        for="typeAnonymous"
      >
        <span translate>Anonymous</span>
      </label>
      <input
        class="btn-check"
        type="radio"
        [(ngModel)]="type"
        value="email"
        name="typeEmail"
        id="typeEmail"
      />
      <label
        class="btn btn-outline-secondary no-wrap"
        [class.active]="type === 'email'"
        for="typeEmail"
      >
        <span translate>E-mail</span>
      </label>
      <input
        class="btn-check"
        type="radio"
        [(ngModel)]="type"
        value="user"
        name="typeUser"
        id="typeUser"
      />
      <label
        class="btn btn-outline-secondary no-wrap"
        [class.active]="type === 'user'"
        for="typeUser"
      >
        <span translate>Existing user</span>
      </label>
    </div>
  </div>
  @if (type == "email") {
    <div class="form-group">
      <input
        class="form-control"
        type="email"
        required
        [(ngModel)]="email"
        name="email"
        [placeholder]="'E-mail' | translate"
        id="createCloudLinkModal-email"
        label
      />
    </div>
  }
  @if (type == "user") {
    <div class="form-group">
      @if (users) {
        <select class="form-control" [(ngModel)]="email" name="user" required>
          <option value="" translate>Select a user</option>
          @for (x of users | naturalOrderBy: "displayName"; track x) {
            <option [ngValue]="x.email">
              {{ x.displayName + " (" + x.email + ")" }}
            </option>
          }
        </select>
      }
    </div>
  }
  <div class="form-group">
    <label translate for="createCloudLinkModal-limit">Limit views</label>
    <input
      class="form-control"
      type="number"
      min="1"
      step="1"
      name="limit"
      [placeholder]="'Unlimited' | translate"
      id="createCloudLinkModal-limit"
      [(ngModel)]="viewLimit"
    />
  </div>
  @if (identity.user?.email || type != "anonymous") {
    <div class="form-group">
      <label>Notification</label>
      @if (identity.user?.email) {
        <div>
          <checkbox
            [(ngModel)]="notifyOnUse"
            name="notifyOnUse"
            [text]="'Notify me when the link is clicked' | translate"
          />
        </div>
      }
      @if (type != "anonymous") {
        <div>
          <checkbox
            [(ngModel)]="sendEmail"
            name="sendEmail"
            [text]="'E-mail the link to user once the upload is complete' | translate"
          />
        </div>
      }
    </div>
  }
</form>
<div class="modal-footer">
  <button
    class="btn btn-outline-primary"
    [clickBlocking]="create"
    [disabled]="!form.form.valid"
    translate
  >
    Create link
  </button>
  <button class="btn btn-outline-secondary" (click)="dismiss()" translate>Cancel</button>
</div>
